import React from 'react';
export var ClearAllIcon = function () { return (React.createElement("svg", { viewBox: "0 0 16 16" },
    React.createElement("path", { d: "M16 1.468L14.532 0L8 6.532L1.468 0L0 1.468L6.532 8L0 14.532L1.468 16L8 9.468L14.532 16L16 14.532L9.468 8L16 1.468Z", fill: "#D44142" }))); };
//# sourceMappingURL=ClearAllIcon.js.map